/**
 * Content Type Enum for frontend domain
 *
 * IMPORTANT: These values must match the ContentType enum in the BFF
 * (packages/bff/src/services/labels/domain/content-type.enum.ts)
 *
 * Defines the possible content types for a standard label.
 * Values are PascalCase to match the API and BFF enum values.
 */
export enum ContentType {
  TEXT = 'Text',
  IMAGE = 'Image',
}
